import { useEffect, useState } from "react";
import { GlobalRequest } from "../../../../../../../common/services/request";
import { Loader } from "../../../../../../../common/components/Loader/Loader";
import { HttpStatusCode } from "axios";
import { Tabs } from "antd";
import { PointingDetailsContext } from "../../../../../core/_context";
import { ContainerDetailsData } from "./ContainerDetailsData";
import { ContainerDetailsInfo } from "./ContainerDetailsInfo";

type PropsType = {
  initialValue?: any;
};

export const ContainerDetails = ({ initialValue }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [initialState, setInitialState] = useState<any>();

  /* const TAB_ITEMS = [
    {
      key: "DATA",
      label: "Données",
      children: <ContainerDetailsData />,
    },
    {
      key: "INFO",
      label: "Informations",
      children: <ContainerDetailsInfo />,
    },
  ]; */

  useEffect(() => {
    if (initialValue) {
      getContainer(initialValue?.["@id"]);
    }
  }, [initialValue]);

  const getContainer = async (url: string) => {
    try {
      setIsLoading(true);
      const res = await GlobalRequest.get(`${url}/controlled`);

      if (res?.status === HttpStatusCode.Ok) {
        setInitialState(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PointingDetailsContext.Provider
      value={{
        data: initialState,
      }}
    >
      <Loader isLoading={isLoading} />
      {/* <Tabs items={TAB_ITEMS} /> */}
      <ContainerDetailsData />
    </PointingDetailsContext.Provider>
  );
};
